import { render, staticRenderFns } from "./maintainanceTaskDetailsList.vue?vue&type=template&id=b2bbdb38&scoped=true"
import script from "./maintainanceTaskDetailsList.vue?vue&type=script&lang=js"
export * from "./maintainanceTaskDetailsList.vue?vue&type=script&lang=js"
import style0 from "./maintainanceTaskDetailsList.vue?vue&type=style&index=0&id=b2bbdb38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2bbdb38",
  null
  
)

export default component.exports